import './pages.css';
import { templates } from '../cms-templates/template';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';

function loadPages(setPages) {
    fetch('/v1/api/pages', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'x-Content-Range': 'items=0-1000',
        },
    })
        .then(response => response.json())
        .then(data => {
            setPages(data);
        })
        .catch(error => {
            toast.error('Failed to fetch pages.');
        });
}

function createPage(loadPages) {
    fetch('/v1/api/pages', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            aliases: document.getElementById('aliases').value.split(' '),
            links: document.getElementById('links').value.split(' ').filter(link => link.length > 0),
            template: document.getElementById('template').value,
        }),
    }).then(response => response.json())
        .then(data => {
            toast.success('Page created successfully.');
            loadPages();
        }).catch(error => {
            toast.error('Failed to create page.');
        });
}

function deletePage(id, loadPages) {
    fetch(`/v1/api/pages/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (response.ok) {
            toast.success('Page deleted successfully.');
            loadPages();
        } else {
            toast.error('Failed to delete page.');
        }
    });
}

export default function Pages({currentPage, fnSetCurrentPage}) {
    const [pages, setPages] = useState([]);

    useEffect(() => {
        loadPages(setPages);
    }, []);

    return <div className='pages'>
        <table>
            <thead>
                <tr>
                    <th><input id='aliases' type='text' placeholder='aliases'/></th>
                    <th><input id='links' type='text' placeholder='links'/></th>
                    <th>
                        <select id="template">
                            {Object.keys(templates).map((template) => (
                                <option value={template}>{template}</option>
                            ))}
                        </select>
                    </th>
                    <th>
                        <button onClick={() => createPage(() =>loadPages(setPages))} title='Create Page'>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                    </th>
                </tr>
            </thead>
            <tbody>
                {pages.map((page) => (
                    <tr className={currentPage && currentPage.id == page.id ? 'active':''} onClick={() => fnSetCurrentPage(page)}>
                        <td className="col-aliases">{page.aliases.join(' ')}</td>
                        <td className="col-links">{page.links.join(' ')}</td>
                        <td className="col-template">{page.template}</td>
                        <td className="col-actions">
                            <button title='Delete' className='no-margin' onClick={() => deletePage(page.id, () => loadPages(setPages))}><FontAwesomeIcon icon={faXmark} /></button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        <ToastContainer />
    </div>
}
